import './footer.css';

function Footer() {
    return <footer className="bg-white">By Riccardo Menon</footer>;
}

export default Footer;
